import { render } from "./BlogTable.vue?vue&type=template&id=02c9c300"
import script from "./BlogTable.vue?vue&type=script&lang=js"
export * from "./BlogTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__